import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/Sidebar.css';
import { FaCaretRight } from 'react-icons/fa';

const sidebarLinks = [
    { label: 'Home', path: '/' },
    { label: 'Text box', path: '/text-box' },
    { label: 'Checkbox', path: '/checkbox' },
    { label: 'Radio button', path: '/radio-button' },
    { label: 'Button', path: '/button' },
    { label: 'Web links', path: '/web-links' },
    { label: 'Dropdown', path: '/drop-down' },
    { label: 'Calendar', path: '/calendar' },
    { label: 'JavaScript Alert', path: '/java-script-alert' },
    { label: 'Iframe', path: '/iframe' },
    { label: 'Nested Iframe', path: '/nested-iframe' },
    { label: 'Multiple windows', path: '/multiple-windows' },
    { label: 'Swipe', path: '/swipe' },
    { label: 'Mouse actions', path: '/mouse-actions' },
    { label: 'Scroll', path: '/scroll' },
    { label: 'Web table', path: '/web-table' },
    { label: 'Synchronization', path: '/synchronization' },
    { label: 'JavaScript Executor', path: '/javascript-executor' },
    { label: 'Download File', path: '/download-file' },
    { label: 'Relative locators', path: '/relative-locators' },
    { label: 'Buttons with messages', path: '/buttons-with-messages' },
    { label: 'Sign up', path: '/sign-up' },
];

const Sidebar = () => {
    return (
        <div className="sidebar-container">
            <div className="sidebar">
                <ul>
                    {sidebarLinks.map((link) => (
                        <li key={link.path}>
                            <NavLink
                                to={link.path}
                                className={({ isActive }) => (isActive ? 'active-link' : '')}
                                end={link.path === '/'}
                            >
                                <FaCaretRight className="link-icon" />
                                <span>{link.label}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;
